import { getUser } from "@utils";

export const getTournamentOptions = () => [
	{
		value: "DROP AND WINS | CASINO",
		key: "drop-and-wins-casino",
	},
	{
		value: "DROP AND WINS | CANLI CASINO",
		key: "drop-and-wins-live-casino",
	},
];

export const getSortOptions = () => [
	{
		value: "casino.most-popular-games",
		key: "most-popular-games",
	},
	{
		value: "casino.asc",
		key: "asc",
		translate: "casino.asc",
	},
	{
		value: "casino.desc",
		key: "desc",
	},
	{
		value: "casino.random",
		key: "random",
	},
];

export const openGame = (game, goToLink, showAlert, params, type) => {
	let user = getUser();

	if (user) {
		const gameId = game.game_id || game.gameId;
		const queryParams = `gameId=${gameId}&provider=${game.provider}`;

		goToLink({
			pathname: "/casino/game",
			search: `?${queryParams}`,
			state: {
				id: game.id,
				hasLobby: game.hasLobby,
				technology: game.technology,
				affiliate: game.affiliate,
				gameId: gameId,
				lang: "en-US",
				practice: 0,
				provider: game.provider,
				localGameType: game.remote_game_category,
				is_live: game.is_live,
				tableName: game.table_name,
				tableId: game.table_id || game.tableId,
				preParams: params,
			},
		});
		if (type === "gameplay") {
			window.location.reload();
		}
	} else {
		showAlert({
			type: "error",
			msg: "LOGIN_OR_SIGNUP_FIRST",
			title: "ERROR",
		});
	}
};
